import { atom } from 'jotai';

export const userAtom = atom<string | undefined>(undefined);
